import { AxiosInstance } from "axios"
import { PrinterQueueDetailsTypes, PrinterQueueTypes } from "./printerQueueTypes"

export enum SupportReportsPrinterQueueQuery {
    PRINTER_QUEUE_FOR_SUPPORT = "printer-queue-for-support",
    DETAILS_PRINTER_QUEUE_FOR_SUPPORT = "details-printer-queue-for-support",
}

type SupportPrinterQueueParams = Readonly<{
    orderId?: string
    merchantId?: number
    startDate: string
    endDate: string
}>

type SupportPrinterQueueDetailsParams = Readonly<{
    printerQueueId: number
}>

export type SupportPrinterQueueResponse = Readonly<{
    printerQueue: PrinterQueueTypes[]
}>

export type SupportPrinterQueueDetailsResponse = Readonly<{
    printerQueueDetails: PrinterQueueDetailsTypes
}>

export async function fetchSupportPrinterQueue(
    { orderId, merchantId, startDate, endDate }: SupportPrinterQueueParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupportPrinterQueueResponse> {
    const url = "/printer/queue"
    const { data } = await axios.get(url, {
        params: {
            orderId,
            merchantId,
            startDate,
            endDate,
        },
        signal,
    })

    return data
}

export async function fetchSupportPrinterQueueDetails(
    { printerQueueId }: SupportPrinterQueueDetailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupportPrinterQueueDetailsResponse> {
    const url = `/printer/queue/${printerQueueId}`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
